import api from './api';

export interface PromptSection {
  title: string;
  prompt: string;
}

export interface Prompt {
  id: number;
  tenant_id: number | null;
  tenant_name?: string | null;
  prompt_type: string;
  name: string;
  general: string | null;
  sections: PromptSection[] | null;
  is_global: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PromptCreate {
  tenant_id?: number | null;
  prompt_type: string;
  name: string;
  general?: string | null;
  sections?: PromptSection[] | null;
  is_global?: boolean;
  is_active?: boolean;
}

export interface PromptUpdate {
  name?: string;
  general?: string | null;
  sections?: PromptSection[] | null;
  is_active?: boolean;
}

class PromptService {
  async getPrompts(promptType?: string, isActive?: boolean): Promise<Prompt[]> {
    const params = new URLSearchParams();
    if (promptType) params.append('prompt_type', promptType);
    if (isActive !== undefined) params.append('is_active', String(isActive));

    const response = await api.get(`/prompts/?${params.toString()}`);
    return response.data.items;
  }

  async getPrompt(id: number): Promise<Prompt> {
    const response = await api.get(`/prompts/${id}`);
    return response.data;
  }

  async createPrompt(prompt: PromptCreate): Promise<Prompt> {
    const response = await api.post('/prompts/', prompt);
    return response.data;
  }

  async updatePrompt(id: number, prompt: PromptUpdate): Promise<Prompt> {
    const response = await api.put(`/prompts/${id}`, prompt);
    return response.data;
  }

  async deletePrompt(id: number): Promise<void> {
    await api.delete(`/prompts/${id}`);
  }

  async copyToTenant(sourcePromptId: number, tenantId: number): Promise<Prompt> {
    // Get the source prompt
    const sourcePrompt = await this.getPrompt(sourcePromptId);

    // Create a copy for the tenant
    const newPrompt: PromptCreate = {
      tenant_id: tenantId,
      prompt_type: sourcePrompt.prompt_type,
      name: `${sourcePrompt.name} (Copy)`,
      general: sourcePrompt.general,
      sections: sourcePrompt.sections,
      is_global: false,
      is_active: true,
    };

    return this.createPrompt(newPrompt);
  }
}

const promptService = new PromptService();
export default promptService;
